import "./App.css";
import { Routes, Route } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ProfilePage from "./pages/ProfilePage/ProfilePage";
import SignupPage from "./pages/SignupPage/SignupPage";
import ForgotPassword from "./pages/ForgetPassword/ForgetPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import LoginPage from "./pages/LoginPage/LoginPage";
import BudgetPage from "./pages/BudgetPage/BudgetPage";
import Homepage from "./pages/HomePage/HomePage";
import IsPrivate from "./components/IsPrivate/IsPrivate";
import IsAnon from "./components/IsAnon/IsAnon";
import PodcastPage from "./pages/PodcastPage/PodcastPage";
import SideBarApp from "./components/SideBarApp/SideBarApp";
import NotFound from "./pages/NotFoundPage/NotFoundPage";

function App() {
  return (
    <div>
      <ToastContainer />
      <SideBarApp />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route
          path="/profile"
          element={
            <IsPrivate>
              <ProfilePage />
            </IsPrivate>
          }
        />

        <Route
          path="/signup"
          element={
            <IsAnon>
              <SignupPage />
            </IsAnon>
          }
        />
        <Route
          path="/login"
          element={
            <IsAnon>
              <LoginPage />
            </IsAnon>
          }
        />
        <Route
          path="/forgetpassword"
          element={
            <IsAnon>
              <ForgotPassword />
            </IsAnon>
          }
        />
        <Route
          path="/resetpassword/:token"
          element={
            <IsAnon>
              <ResetPassword />
            </IsAnon>
          }
        />

        <Route
          path="budget"
          element={
            <IsPrivate>
              <BudgetPage />
            </IsPrivate>
          }
        />
        <Route
          path="Podcasts"
          element={
            <IsPrivate>
              <PodcastPage />
            </IsPrivate>
          }
        />
         
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
